import * as recommendationManager from '$domain/model/recommendation/recommendation.manager'
import { draft } from '$utils/services/formDraftService'
import { Steps } from '$views/RecommendationsForms/RecommendationForm/RecommendationForm.model'
import { mapCaresToCaresModel } from '$domain/model/recommendation/recommendation.mapper'
import { RecommendationServiceOutSession } from '$domain/model/recommendation/recommendation.model'
import { tagManager } from '$infrastructure/tagManager/tagManager'
import { mapCaredToTagManager } from '$domain/model/cared/cared'

export const createNewRecommendationRequestOutSession = async registerInfo => {
  const locationStep = draft.get(Steps.locationStep)
  const careStep = draft.get(Steps.careStep)
  const dateStep = draft.get(Steps.dateStep)
  const personStep = draft.get(Steps.personStep)

  const service: RecommendationServiceOutSession = {
    locality: locationStep.address,
    latitude: locationStep.latitude,
    longitude: locationStep.longitude,
    serviceDays: dateStep,
    cares: mapCaresToCaresModel(careStep),
    age: personStep.age,
    careeType: personStep.careType,
    extraInformation: careStep.textarea,
    province: locationStep.province,
    gender: personStep.gender,
    name: registerInfo.name,
    phone: registerInfo.phone,
    email: registerInfo.email,
  }

  const recomendationRequest = recommendationManager.newRecommendationServiceOutSession(service)
  tagManager.push({
    event: 'publishoffer',
    userSegment: mapCaredToTagManager(personStep.careType),
    serviceType: 'Corto',
    offerType: 'recomendación',
  })

  return recomendationRequest
}



// WEBPACK FOOTER //
// ./src/services/customer/recommendationRequestOutSession/recommendationRequestOutSession.service.ts